/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import {
  ADVANCED_FORMS,
  CONTENT_MANAGEMENT,
  DATA_SERVICES,
  INTEGRATIONS,
  SEARCH,
} from 'apps/console-core/src/Constants/DxpCapabilities/DxpCapabilityItems.constants';

/**
 * The paths for each screen.
 */
export const screenPaths = {
  advancedForms: ADVANCED_FORMS.path,
  connectWorkspaces: INTEGRATIONS.path,
  contentManagement: CONTENT_MANAGEMENT.path,
  dataServices: DATA_SERVICES.path,
  search: SEARCH.path,
};
